module.exports = __webpack_public_path__ + "img/decision.097c6e88.svg";